module.exports = "/_next/static/images/CollectionAPI-0c7b8b388b47955149ee89558c29a100.webp";